import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';
import List from './components/List';
const Statistics = () => {
  const { dailyConsumption } = usePermission();

  // Nếu không có quyền view, hiển thị trang 403
  if (!dailyConsumption.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Thống kê tiêu thụ theo ngày nhiều khách hàng' }]}
        />
      </div>
      <List />
    </ContainerBody>
  );
};
export default compose(withPaginate)(Statistics);
